export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL
export const API_URL = process.env.REACT_APP_API_URL
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT
export const MEETING_SOCKET_URL = process.env.REACT_APP_MEETING_SOCKET_URL
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY
export const USER_BUCKET_URL = process.env.REACT_APP_USER_BUCKET_URL
export const STUN_URL = process.env.REACT_APP_STUN_URL
export const TURN_URL = process.env.REACT_APP_TURN_URL
export const TURN_USERNAME = process.env.REACT_APP_TURN_USERNAME
export const TURN_CREDENTIAL = process.env.REACT_APP_TURN_CREDENTIAL
export const MEDIA_SERVER_URL_MAP = {
  '3.140.89.53:9292': 'wss://mediaserver1.coderscout.io',
  '3.142.15.75:9292': 'wss://mediaserver2.coderscout.io',
  '3.21.223.89:9292': 'wss://mediaserver3.coderscout.io',
  '5.161.20.218:9292': 'wss://mediaserver4.coderscout.io'
}
export const INTERNET_SPEED_TEST_URL = 'https://speedtest.coderscout.io/'
export const BLOCK_UI_IN_MINS = process.env.REACT_APP_BLOCK_UI
  ? Number(process.env.REACT_APP_BLOCK_UI)
  : 3
export const NO_FACE_DETECTION_BLOCK_UI_IN_MINS = process.env
  .REACT_APP_NO_FACEDETECTION_BLOCK
  ? Number(process.env.REACT_APP_NO_FACEDETECTION_BLOCK)
  : 3
